// extracted by mini-css-extract-plugin
export default {"input":"Input_input__7zljM","input--error":"Input_input--error__NquyD","label__icon":"Input_label__icon__+3BNK","search__wrap":"Input_search__wrap__T3Ojd"};